import template from './frequent-orders-list.html';
export var FrequentOrdersListComponent = {
    template: template,
    controller: /** @class */ (function () {
        function FrequentOrdersListComponent() {
            'ngInject';
            this.sortType = 'product'; // set the default sort type
            this.sortReverse = false; // set the default sort order
            this.searchProduct = ''; // set the default search/filter term
            // create the list of order
            this.products = [
                {
                    product: 'product 1',
                    productDescription: 'Product Description 1',
                    productImageUrl: 'https://images.emersonecologics.com/ProductImage/M//M45341_thumb.jpg',
                    orderDate: '11/9/2016, 10:29 AM',
                    orderNumber: '0006243597',
                    orderedBy: 'Trisha Wilson',
                    shippedTo: 'Southeast Headquarters',
                    estShippingDate: '10/21/2016',
                    qtyOrdered: 1,
                    qtyBackordered: 1,
                    total: 67.29,
                    items: 3,
                    trackOrders: [
                        { id: 1, trackingNumber: 'TBA102967947000' },
                        { id: 2, trackingNumber: 'RAD102967947001' },
                        { id: 3, trackingNumber: 'YOY102967947002' },
                    ],
                },
                {
                    product: 'product 2',
                    productDescription: 'Product Description 2',
                    productImageUrl: 'https://images.emersonecologics.com/ProductImage/N//N31250_thumb.jpg',
                    orderDate: '11/10/2016, 10:29 AM',
                    orderNumber: '0006243598',
                    orderedBy: 'Trisha Wilson',
                    shippedTo: 'Southeast Headquarters',
                    estShippingDate: '10/21/2016',
                    qtyOrdered: 1,
                    qtyBackordered: 1,
                    total: 67.29,
                    items: 3,
                    trackOrders: [
                        { id: 1, trackingNumber: 'TBA102967947000' },
                        { id: 2, trackingNumber: 'RAD102967947001' },
                        { id: 3, trackingNumber: 'YOY102967947002' },
                    ],
                },
                {
                    product: 'product 3',
                    productDescription: 'Product Description 2',
                    productImageUrl: 'https://images.emersonecologics.com/ProductImage/N//N31250_thumb.jpg',
                    orderDate: '11/10/2016, 10:29 AM',
                    orderNumber: '0006243598',
                    orderedBy: 'Trisha Wilson',
                    shippedTo: 'Southeast Headquarters',
                    estShippingDate: '10/21/2016',
                    qtyOrdered: 1,
                    qtyBackordered: 1,
                    total: 67.29,
                    items: 3,
                    trackOrders: [
                        { id: 1, trackingNumber: 'TBA102967947000' },
                        { id: 2, trackingNumber: 'RAD102967947001' },
                        { id: 3, trackingNumber: 'YOY102967947002' },
                    ],
                },
            ];
            // set the default amount of items being displayed
            this.limit = 10;
        }
        // loadMore function
        FrequentOrdersListComponent.prototype.loadMore = function () {
            var increamented = this.limit + 10;
            this.limit = increamented > this.orders.length ? this.orders.length : increamented;
        };
        return FrequentOrdersListComponent;
    }()),
};
//# sourceMappingURL=frequent-orders-list.component.js.map